export const finishedConfigurations = {
  title: 'Finished Configuration Templates',
  signature: 'Signature',
  type: 'Type',
  mail: 'Mail',
  confirmedDate: 'Confirmed date',
  displayConfiguration: 'Display configuration templates',
  search: 'Search',
  shared: 'Shared',
  sectionInfo: {
    signature: 'Signature',
    source: 'Source',
    updatedAt: 'Modified',
    email: 'Email address',
  },
  user: {
    notGivenToken: 'Not valid URL. No token found.',
    invalidToken: 'No data found for the provided token',
    expiredToken: 'The provided token has expired',
  },
}
